import {Injectable} from '@angular/core';
import { PlottableModel} from '4d-mapper';
import { MapDataService } from './map-data.service';
import { ClickHandler, CursorEvent, MapEvent, CameraDirection, CameraEvent, Coordinate } from './map-event.objects'
import { Store } from 'vasat/dist/src/veflux';


/**
 * The Service to handle all streamEvents to do with the map. 
 * As well as take commands from componets that wish to maniplate the map's camrea and cusor
 */
@Injectable()
export class MapEventService implements ClickHandler{
  
  
  loading:boolean = false
  error:any

  private _clickStack:ClickHandler[] = []

  private _map = new Store(MapEvent)
  private _cursor = new Store(CursorEvent)
  private _camera = new Store(CameraEvent)

  get cursor(){ return this._cursor; }
  get map(){ return this._map; }
  get camera(){ return this._camera; }

  constructor(public mapData:MapDataService){}

  flyCameraTo(p:PlottableModel<any>|CameraDirection){
    this.camera.emmit('request_move',null,p)
  }

  cameraStartingMove(){
    if(this.camera.value)
      this.camera.emmit('start_move',this._camera)
  }
  
  setClickListener(component:ClickHandler){
    if(!this._clickStack.find(c => c == component))
      this._clickStack.push(component)
  }

  clearClickListener(component:ClickHandler){
    this._clickStack = this._clickStack.filter(c => c != component)
  }

  onMapClicked(position: Coordinate, feature: PlottableModel<any>, isRightClick: boolean): boolean {
    // pass the click to the first item in the stack, working down if the first item returns false
    if(this._clickStack.length){
      var lastEvent = false
      for(var x = this._clickStack.length -1; x >= 0 && !lastEvent; x--){
        lastEvent = this._clickStack[x].onMapClicked(position,feature,isRightClick)
      }
      return lastEvent
    }
    throw new Error("Method not implemented.");
  }

}
